// The PROSE grammar: sentences carrying judgement (#11426).
//
// Generated prose carries an evidence footer — what it was derived from, and
// when. Prose a human wrote once (a deal description, a pass reason) carries
// no footer and no AI mark: marking everything would teach the reader to stop
// seeing the mark.

import React from "react";

/** Precedes the as-of, so the line reads as machine provenance. */
const AI_MARK = "✦";

export interface ProseProps {
  children?: React.ReactNode;
  /** Where the generated text came from. Human-written prose passes none. */
  sources?: React.ReactNode[];
  /** When the generation last ran. Human-written prose passes none. */
  asOf?: string | null;
  /** Rendered at the right of the footer — a "Full read" doorway, say. */
  trailing?: React.ReactNode;
}

/**
 * Renders nothing when it has nothing to say, rather than an empty card.
 */
export const Prose: React.FC<ProseProps> = ({
  children,
  sources,
  asOf,
  trailing,
}) => {
  if (React.Children.count(children) === 0) return null;

  const hasEvidence = Boolean((sources && sources.length > 0) || asOf);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--fp-gap-tight)",
      }}
    >
      <div
        style={{
          fontFamily: "var(--fp-font-ui)",
          fontSize: "var(--fp-t-body)",
          lineHeight: "var(--fp-lh-prose)",
          letterSpacing: "var(--fp-track-body)",
          color: "var(--fp-ink-2)",
        }}
      >
        {children}
      </div>

      {hasEvidence ? (
        <footer
          style={{
            display: "flex",
            alignItems: "baseline",
            flexWrap: "wrap",
            gap: "var(--fp-gap-tight)",
            paddingTop: "var(--fp-gap-tight)",
            borderTop: "1px solid var(--fp-border)",
            fontFamily: "var(--fp-font-ui)",
            fontSize: "var(--fp-t-meta)",
            color: "var(--fp-ink-3)",
          }}
        >
          {sources && sources.length > 0
            ? sources.map((source, i) => (
                // Sources are a fixed list rendered in order and never
                // reordered, so the index is a stable key.
                <span key={i}>{source}</span>
              ))
            : null}
          {asOf ? (
            <span style={{ marginLeft: "auto" }}>
              {AI_MARK} AI · updated {asOf}
            </span>
          ) : null}
          {trailing}
        </footer>
      ) : null}
    </div>
  );
};
